// document.addEventListener('DOMContentLoaded', () => {
//   document.querySelectorAll('.product-media-container--image').forEach(container => {
//     const img = container.querySelector('img.product-media__image');
//     if (!img) return;

//     // Load high-res image if available
//     const hiRes = img.getAttribute('data_max_resolution');
//     if (hiRes) {
//       const highResImage = new Image();
//       highResImage.src = hiRes;
//       highResImage.onload = () => img.src = hiRes;
//     }

//     let zoomActive = false;

//     // Click to enable zoom mode
//     container.addEventListener('click', e => {
//       zoomActive = !zoomActive;
//       if (zoomActive) {
//         container.style.cursor = 'zoom-in';
//       } else {
//         img.style.transform = 'scale(1)';
//         img.style.transformOrigin = 'center center';
//         container.style.cursor = 'default';
//       }
//     });

//     // Mouse move zoom (only if zoomActive)
//     container.addEventListener('mousemove', e => {
//       if (!zoomActive) return;
//       const rect = container.getBoundingClientRect();
//       const x = ((e.clientX - rect.left) / rect.width) * 100;
//       const y = ((e.clientY - rect.top) / rect.height) * 100;

//       img.style.transformOrigin = `${x}% ${y}%`;
//       img.style.transform = 'scale(2)'; // adjust zoom level
//       img.style.transition = 'transform 0.05s ease';
//     });

//     // Reset zoom when mouse leaves (optional)
//     container.addEventListener('mouseleave', () => {
//       if (!zoomActive) return;
//       img.style.transform = 'scale(1)';
//       img.style.transformOrigin = 'center center';
//     });
//   });
// });

// document.addEventListener('DOMContentLoaded', () => {
//   document.querySelectorAll('.product-media-container--image').forEach(container => {
//     const img = container.querySelector('img.product-media__image');
//     if (!img) return;

//     // Load high-res image if available
//     const hiRes = img.getAttribute('data_max_resolution');
//     if (hiRes) {
//       const highResImage = new Image();
//       highResImage.src = hiRes;
//       highResImage.onload = () => img.src = hiRes;
//     }

//     let zoomActive = false;
//     const zoomScale = 1.5; // you can change zoom level (1.5, 2, 3 etc.)

//     // Click to toggle zoom mode
//     container.addEventListener('click', () => {
//       zoomActive = !zoomActive;
//       if (!zoomActive) {
//         img.style.transform = 'scale(1)';
//         img.style.transformOrigin = 'center center';
//         container.style.cursor = 'default';
//       } else {
//         container.style.cursor = 'zoom-in';
//       }
//     });

//     // Mouse move zoom (only if zoomActive)
//     container.addEventListener('mousemove', e => {
//       if (!zoomActive) return;

//       const rect = container.getBoundingClientRect();
//       const x = ((e.clientX - rect.left) / rect.width) * 100;
//       const y = ((e.clientY - rect.top) / rect.height) * 100;

//       // Apply zoom **within container**
//       img.style.transformOrigin = `${x}% ${y}%`;
//       img.style.transform = `scale(${zoomScale})`;
//       img.style.transition = 'transform 0.05s ease';
//     });

//     // Reset zoom on mouse leave
//     container.addEventListener('mouseleave', () => {
//       if (zoomActive) {
//         img.style.transform = 'scale(1)';
//         img.style.transformOrigin = 'center center';
//       }
//     });
//   });
// });

document.addEventListener('DOMContentLoaded', () => {
  const zoomScale = 1.5; // change zoom level here

  // helper
  const getImg = container => container && container.querySelector('img.product-media__image');

  // try several attribute name variants (yours used underscore which is uncommon)
  function getHiResUrl(img) {
    if (!img) return null;
    return img.getAttribute('data_max_resolution')   // original in your snippet (kept for compatibility)
      || img.getAttribute('data-max-resolution')    // common HTML data-* form
      || img.dataset.maxResolution                  // dataset friendly
      || null;
  }

  function preloadHiRes(img) {
    const hi = getHiResUrl(img);
    if (!hi || img.dataset.hiResPreloaded === 'true') return;
    const pre = new Image();
    pre.src = hi;
    pre.onload = () => {
      // swap to hi-res once loaded (optional: compare sizes if needed)
      if (img.src !== hi) img.src = hi;
      img.dataset.hiResPreloaded = 'true';
    };
  }

  // minimal CSS for smooth transform and clamped overflow
  const css = `
    .product-media-container--image { overflow: hidden; }
    .product-media-container--image img.product-media__image {
      transition: transform 0.12s ease;
      will-change: transform;
      display: block;
      max-width: 100%;
    }
  `;
  const styleTag = document.createElement('style');
  styleTag.textContent = css;
  document.head.appendChild(styleTag);

  // preload existing images
  document.querySelectorAll('.product-media-container--image img.product-media__image')
    .forEach(preloadHiRes);

  // Click toggles zoom mode (store per-container state on dataset)
  document.addEventListener('click', (e) => {
    const container = e.target.closest('.product-media-container--image');
    if (!container) return;
    const img = getImg(container);
    if (!img) return;

    const active = container.dataset.zoomActive === 'true';
    container.dataset.zoomActive = (!active).toString();
    // cursor hint: when zoom is active, clicking again will "zoom out"
    container.style.cursor = (!active) ? 'zoom-out' : 'zoom-in';

    // make sure hi-res is preloaded for newly-added image
    if (!img.dataset.hiResPreloaded) preloadHiRes(img);

    // optionally reset transform origin/scale so move starts clean
    img.style.transformOrigin = 'center center';
    img.style.transform = 'scale(1)';
  });

  // pointermove for pan-zoom while zoom mode active
  document.addEventListener('pointermove', (e) => {
    const container = e.target.closest('.product-media-container--image');
    if (!container || container.dataset.zoomActive !== 'true') return;
    const img = getImg(container);
    if (!img) return;

    const rect = container.getBoundingClientRect();
    // protect against division by zero
    if (rect.width === 0 || rect.height === 0) return;

    const x = Math.max(0, Math.min(100, ((e.clientX - rect.left) / rect.width) * 100));
    const y = Math.max(0, Math.min(100, ((e.clientY - rect.top) / rect.height) * 100));

    img.style.transformOrigin = `${x}% ${y}%`;
    img.style.transform = `scale(${zoomScale})`;
  });

  // pointerout: when pointer leaves the container, reset transform (but keep zoomActive)
  document.addEventListener('pointerout', (e) => {
    const container = e.target.closest('.product-media-container--image');
    if (!container) return;
    // ensure pointer actually left the container, not just moved to a child
    if (container.contains(e.relatedTarget)) return;

    if (container.dataset.zoomActive === 'true') {
      const img = getImg(container);
      if (img) {
        img.style.transform = 'scale(1)';
        img.style.transformOrigin = 'center center';
      }
    }
  });

  // MutationObserver: preload hi-res for newly inserted images (useful when variant changes replace DOM)
  const observer = new MutationObserver(mutations => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        if (node.matches && node.matches('.product-media-container--image')) {
          preloadHiRes(node.querySelector('img.product-media__image'));
        } else {
          const imgs = node.querySelectorAll && node.querySelectorAll('.product-media-container--image img.product-media__image');
          imgs && imgs.forEach(preloadHiRes);
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
});


